import { Cancel, CheckCircle, VerifiedUser } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextareaAutosize,
} from "@mui/material";

const ConfirmationDialog = ({
  confirmationMessage,
  openConfirmDialog,
  handleCloseDialog,
  messageTitle,
  dialogFunction,
  setRejectReason,
}) => {
  return (
    <div>
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle color="warning">{messageTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText color="info" id="alert-dialog-description">
            {confirmationMessage}
          </DialogContentText>
          {messageTitle !== "REJECT REPORT" ? (
            ""
          ) : (
            <TextareaAutosize
              aria-label="minimum height"
              minRows={5}
              placeholder="Enter reject reason!"
              onChange={(e) => setRejectReason(e.target.value)}
              style={{
                width: "100%",
                marginTop: "5px",
                borderRadius: "5px",
                padding: "2px",
              }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="success"
            startIcon={<CheckCircle />}
            onClick={dialogFunction}
          >
            YES
          </Button>
          <Button
            color="success"
            variant="contained"
            startIcon={<Cancel />}
            onClick={handleCloseDialog}
            autoFocus
          >
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmationDialog;
